import { useQuery } from '@tanstack/react-query';

import { GetAllocatedPropertiesParams, getHintAllocatedProperties } from '~/services/ConnectionGoogleService';

export const allocatedPropertiesQueryKeys = {
  all: ['allocatedProperties'] as const,
  lists: () => [...allocatedPropertiesQueryKeys.all, 'list'] as const,
  list: (params: GetAllocatedPropertiesParams) => [...allocatedPropertiesQueryKeys.lists(), params] as const,
};

export function useGetAllocatedProperties(params: GetAllocatedPropertiesParams | null) {
  return useQuery({
    queryKey: params ? allocatedPropertiesQueryKeys.list(params) : allocatedPropertiesQueryKeys.lists(),
    queryFn: async ({ signal }) => {
      return getHintAllocatedProperties(params, { signal });
    },
    enabled: !!params,
  });
}
